var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"logs"}},[(_vm.logs.length > 0)?_c('div',{staticClass:"log"},[_c('h1',[_vm._v(_vm._s(_vm.logs[_vm.logs.length - 1].message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }